import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	DepartmentModel,
	departmentApi,
	DepartmentNS,
	departmentSlice,
	departmentSelectors,
} from 'Pages/departments'
import { errorHandler, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'
import { Deserialize } from 'cerialize'

function* getList(action: DepartmentNS.GetDepartmentList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(departmentSlice.actions.clearAll())
		}
		const res = yield* call(departmentApi.getAll, requestParams)
		const departments = new ResponseCatalog<DepartmentModel>(res)
		departments.entries = departments.entries.map((item) => Deserialize(item, DepartmentModel))
		if (!clear) {
			const oldDepartments = yield* select(departmentSelectors.selectEntries)
			departments.entries = oldDepartments.concat(res.entries)
		}
		yield* put(departmentSlice.actions.setDepartmentList(departments))
		yield* put(departmentSlice.actions.setRequestParams(requestParams))
		yield* put(gridSlice.actions.setLoading(false))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getOne(action: DepartmentNS.GetOne) {
	try {
		yield* put(departmentSlice.actions.setIsLoading(true))
		const res = yield* call(departmentApi.getOne, action.payload)
		yield* put(departmentSlice.actions.setOne(Deserialize(res, DepartmentModel)))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(departmentSlice.actions.setIsLoading(false))
	}
}

function* createOne(action: DepartmentNS.CreateOne) {
	try {
		yield* put(departmentSlice.actions.setIsLoading(true))
		const res = yield* call(departmentApi.createOne, action.payload.data)
		yield* put(departmentSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.pp.department))
		action.payload.callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(departmentSlice.actions.setIsLoading(false))
	}
}

function* updateOne(action: DepartmentNS.UpdateOne) {
	try {
		yield* put(departmentSlice.actions.setIsLoading(true))
		const res = yield* call(departmentApi.updateOne, action.payload.id, action.payload.data)
		yield* put(departmentSlice.actions.setOne(res))
		action.payload.callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(departmentSlice.actions.setIsLoading(false))
	}
}

function* createMass(action: DepartmentNS.createMass) {
	try {
		yield* call(departmentApi.createMass, { file: action.payload })
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* departmentSaga() {
	yield* takeLatest(departmentSlice.actions.getDepartmentList.type, getList)
	yield* takeLatest(departmentSlice.actions.getOne.type, getOne)
	yield* takeLatest(departmentSlice.actions.createOne.type, createOne)
	yield* takeLatest(departmentSlice.actions.updateOne.type, updateOne)
	yield* takeLatest(departmentSlice.actions.createMass.type, createMass)
}
